module.exports = __webpack_public_path__ + "img/course-5.210a2b97.jpeg";